import { defineComponent as i, openBlock as o, createElementBlock as e, mergeProps as m, unref as n, renderSlot as p, createElementVNode as l, createCommentVNode as Z } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, M = { key: 1 }, L = { key: 2 }, f = { key: 3 }, h = { key: 4 }, k = { key: 5 }, w = {
  name: "ScalarIconProhibit"
}, b = /* @__PURE__ */ i({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const A = s, { bind: d, weight: r } = u(A);
    return (a, t) => (o(), e("svg", m({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, n(d)), [
      p(a.$slots, "default"),
      n(r) === "bold" ? (o(), e("g", g, t[0] || (t[0] = [
        l("path", { d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm84,108a83.6,83.6,0,0,1-16.75,50.28L77.72,60.75A84,84,0,0,1,212,128ZM44,128A83.6,83.6,0,0,1,60.75,77.72L178.28,195.25A84,84,0,0,1,44,128Z" }, null, -1)
      ]))) : n(r) === "duotone" ? (o(), e("g", M, t[1] || (t[1] = [
        l("path", {
          d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm88,104a87.56,87.56,0,0,1-20.41,56.28L71.72,60.4A88,88,0,0,1,216,128ZM40,128A87.56,87.56,0,0,1,60.41,71.72L184.28,195.6A88,88,0,0,1,40,128Z" }, null, -1)
      ]))) : n(r) === "fill" ? (o(), e("g", L, t[2] || (t[2] = [
        l("path", { d: "M200,128a71.69,71.69,0,0,1-15.78,44.91L83.09,71.78A71.95,71.95,0,0,1,200,128ZM56,128a71.95,71.95,0,0,0,116.91,56.22L71.78,83.09A71.69,71.69,0,0,0,56,128Zm180,0A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-20,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }, null, -1)
      ]))) : n(r) === "light" ? (o(), e("g", f, t[3] || (t[3] = [
        l("path", { d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm90,102a89.6,89.6,0,0,1-22.29,59.22L68.78,60.29A89.95,89.95,0,0,1,218,128ZM38,128A89.6,89.6,0,0,1,60.29,68.78L187.22,195.71A89.95,89.95,0,0,1,38,128Z" }, null, -1)
      ]))) : n(r) === "regular" ? (o(), e("g", h, t[4] || (t[4] = [
        l("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm88,104a87.56,87.56,0,0,1-20.41,56.28L71.72,60.4A88,88,0,0,1,216,128ZM40,128A87.56,87.56,0,0,1,60.41,71.72L184.28,195.6A88,88,0,0,1,40,128Z" }, null, -1)
      ]))) : n(r) === "thin" ? (o(), e("g", k, t[5] || (t[5] = [
        l("path", { d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm92,100a91.67,91.67,0,0,1-24.21,62.13L65.87,60.21A92,92,0,0,1,220,128ZM36,128A91.67,91.67,0,0,1,60.21,65.87L190.13,195.79A92,92,0,0,1,36,128Z" }, null, -1)
      ]))) : Z("", !0)
    ], 16));
  }
});
export {
  b as default
};
